<template>
  <div id="food-diary">
    <mu-paper class="foodbar">
      <mu-content-block class="foodBar inner">
        <mu-row gutter>
          <mu-col desktop="30" width="25" tablet="30" align="right">
            <mu-flexbox>
              <mu-flexbox-item align="right">
                <mu-icon-button
                  @click.native="subtractDate()"
                  icon="chevron_left"
                ></mu-icon-button>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
          <mu-col width="50" style="flex: auto" align="center">
            <mu-flexbox align="center center" justify="center center" style="height: 46px;">
              <mu-flexbox-item ref="datepicker" class="c-datepicker-btn mediumTitle" align="center" grow>
                <mu-flexbox justify="center center" align="center" wrap="disallow" style="position:relative;">
                  <mu-flexbox-item align="center" style="cursor: pointer">
                    <mu-date-picker
                      class="hiddenPicker"
                      inputClass="datePicker"
                      :okLabel="$t('message.okText')"
                      :cancelLabel="$t('message.cancelText')"
                      :dateTimeFormat="dateFormat"
                      format="DD-MM-YYYY"
                      v-model="currentDate.ddmmyy"
                      fullWidth></mu-date-picker>
                    <span>
                       <mu-icon style="position:relative;top:4px;" value="date_range"></mu-icon>
                      {{currentDate.presentational}}
                      <span v-if="activeTab !== 1">
                        - {{toDate}}
                      </span>

                    </span>
                  </mu-flexbox-item>
                </mu-flexbox>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
          <mu-col desktop="30" width="25" tablet="30" align="left">
            <mu-flexbox>
              <mu-flexbox-item>
                <mu-icon-button
                  @click.native="addDate()"
                  :disabled="isToday(currentDate.actual)"
                  icon="chevron_right"
                ></mu-icon-button>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
        </mu-row>
      </mu-content-block>
    </mu-paper>
    <div class="content" style="margin-top: 46px">
      <tab-selector
        v-model="activeTab"
        value-key="days"
        text-key="title"
        :list="selectorOptions"
      ></tab-selector>

      <alert type="danger" icon="warning" v-if="!hasData">
        <div slot="content">
          {{$t('message.cardEmpty')}}
        </div>
      </alert>

      <food-diary-stacked-history
        v-if="graphReady && hasData"
        :data="graph"
      ></food-diary-stacked-history>
    </div>
  </div>
</template>

<script>


  import dateFormat from "../../../helpers/DatePickerManager"
  import config from '../../../config'
  import axios from 'axios';
  
  import foodDiaryStackedHistory from '../../../components/FoodDiary/Graphs/StackedHistory/stackedBar'
  import TabSelector from "../../../components/Settings/TabSelector/TabSelector";
  import Alert from "../../../components/Alert/Alert";

  const desiredDay = 0;
  let CancelToken = axios.CancelToken;
  let cancel = null;

  export default {
    watch: {
      "currentDate.ddmmyy": function () {
        let self = this;
        self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').format('Do MMMM YY');
        self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY');
        self.$forceUpdate();
        self.getData();
      },
      "activeTab": function () {
        let self = this;
        if (self.activeTab === 7) {
          self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('week').format('Do MMMM YY');
          self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('week');
        }
        if (self.activeTab === 30) {
          self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('month').format('Do MMMM YY');
          self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').startOf('month');

        }
        if(self.activeTab === 1) {
          self.currentDate.presentational = moment().startOf('day').format('Do MMMM YY');
          self.currentDate.actual = moment();
        }
        self.$forceUpdate();
        self.getData();
      }
    },
    data() {
      return {
        activeTab: 30,
        dateFormat: dateFormat,
        toDate: "",
        currentDate: {
          ddmmyy: moment().startOf('month').format('DD-MM-YYYY HH:mm a'),
          actual: moment().startOf('month').utc(),
          presentational: moment().startOf('month').format('Do MMMM YY')
        },
        selectorOptions: [
          {
            title: 'Daily',
            value: 'DAILY',
            days: 1
          },
          {
            title: 'Weekly',
            value: 'WEEKLY',
            days: 7
          },
          {
            title: 'Monthly',
            value: 'MONTHLY',
            days: 30
          }
        ],
        graphReady: false,
        hasData: true,
        graph: {
          labels: [],
          datasets: []
        }
      }
    },
    components: {
      Alert,
      TabSelector,
      foodDiaryStackedHistory
    },
    methods: {
      isToday: function isToday(date) {
        return moment(date).isSame(moment().utc().add(1, 'hour'), 'day')
      },
      addDate: function addDate() {
        let self = this;
        if (self.activeTab === 7) {
          self.currentDate.actual.add(1, 'weeks').startOf('week');
        }
        if (self.activeTab === 30) {
          self.currentDate.actual.add(1, 'months').startOf('month');
        }
        if(self.activeTab === 1) {
          self.currentDate.actual.add(1, 'day');
        }
        self.$nextTick(function () {
          self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
          self.currentDate.presentational = self.currentDate.actual.format('Do MMMM YY');
        })
      },
      subtractDate: function subtractDate() {
        let self = this;
        if (self.activeTab === 7) {
          self.currentDate.actual.subtract(1, 'weeks').startOf('week')
        }
        if (self.activeTab === 30) {
          self.currentDate.actual.subtract(1, 'months').startOf('month');
        }
        if(self.activeTab === 1) {
          self.currentDate.actual.subtract(1, 'day');
        }
        self.$nextTick(function () {
          self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
          self.currentDate.presentational = self.currentDate.actual.format('Do MMMM YY');
        })
      },
      getData() {
        let self = this;
        if (cancel !== null) {
          cancel();
          cancel = null;
        }

        self.graphReady = false;
        self.hasData = true;
        self.graph.labels = [];
        self.graph.datasets = [];

        let dateObject = moment(self.currentDate.actual);
        let toDate;
        let fromDate;
        if (self.activeTab === 7) {
          self.toDate = self.currentDate.actual.endOf('week').format('Do MMMM YY');
          fromDate = self.currentDate.actual.startOf('week').format('YYYY-MM-DD');
          toDate = self.currentDate.actual.endOf('week').format('YYYY-MM-DD');
        }
        if (self.activeTab === 30) {
          self.toDate = self.currentDate.actual.endOf('month').format('Do MMMM YY');
          fromDate = self.currentDate.actual.startOf('month').format('YYYY-MM-DD');
          toDate = self.currentDate.actual.endOf('month').format('YYYY-MM-DD');
        }
        if (self.activeTab === 1) {
          self.toDate = self.currentDate.actual.endOf('day').format('Do MMMM YY');
          fromDate = self.currentDate.actual.startOf('day').format('YYYY-MM-DD');
          toDate = self.currentDate.actual.endOf('day').format('YYYY-MM-DD');
        }

        axios.get(config.apiUrl + 'graph/nutrition/v2/', {
          params: {
            toDate: toDate,
            fromDate: fromDate,
            type: 'nutrients'
          },
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          })
        })
          .then(function (response) {
            self.graph.labels = response.data.labels;
            let datasetLength = response.data.series.length - 1;
            for (let i = 0; i < datasetLength; i++) {
              let key = response.data.series[i], color;
              if (key === 'Fat') {
                color = '#C44FD3';
              }
              if (key === 'Carbohydrate') {
                color = '#31DAD9';
              }
              if (key === 'Protein') {
                color = '#E66555'
              }
              self.graph.datasets.push({
                label: response.data.series[i],
                backgroundColor: color,
                data: response.data.data[i],
                percentages: response.data.percentages[i]
              })
            }
            self.graphReady = true;
          })
          .catch(function () {
            self.graphReady = false;
            self.hasData = false;
          });
      }
    },
    mounted() {
      let self = this;
      self.activeTab = 30;
      self.getData();
    }
  }
</script>



// WEBPACK FOOTER //
// History.vue?643cb878